<template>
  <div v-if="lastKhorooj.RequestID > 0">
    <div>
      <div class="parent">
        <v-card class="description">
          <v-card-title><ul v-html="fullText"></ul></v-card-title>
        </v-card>
        <div class="img">
          <img
            src="../../assets/passport.jpg"
            style="width: 100%; border-radius: 15px"
          />
        </div>
      </div>
      <v-card class="form">
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <b>تاریخ شروع سفر:</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="6">
            <v-btn
              class="form-center"
              color="orange white--text"
              rounded
              @click="onClickDate(1)"
            >
              {{ startSelected ? startDate : "انتخاب تاریخ" }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <b>تاریخ پایان سفر:</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="6">
            <v-btn
              class="form-center"
              color="orange white--text"
              rounded
              @click="onClickDate(2)"
            >
              {{ endSelected ? endDate : "انتخاب تاریخ" }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6">
            <b>سفر را انجام نداده ام</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="6">
            <v-simple-checkbox
              class="form-center"
              v-model="noTrip"
              :ripple="false"
              @input="resetValues"
            ></v-simple-checkbox>
          </v-col>
        </v-row>
        <v-row class="ltr">
          <v-btn
            color="primary white--text"
            class="register"
            rounded
            @click="applyRequest"
          >
            ثبت وضعیت سفر
          </v-btn>
        </v-row>
      </v-card>
    </div>
    <date-picker
      ref="datepicker1"
      v-model="startDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="endDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      :min="startDate"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
  </div>
  <div v-else>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import { saveLastKhorooj } from "@/api/khorooj";
import Dialog from "@/components/Dialog";
import { TODAY } from "@/utils/constants";
export default {
  data() {
    return {
      startDate: TODAY,
      endDate: TODAY,
      noTrip: false,
      startSelected: false,
      endSelected: false,
    };
  },
  methods: {
    onCloseDialog() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.$router.push("/khorooj-index");
    },
    /**
     * user want to change date
     */
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    /**
     * user changed date
     */
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.$router.push({ path: "/index" });
    },

    resetValues() {
      if (this.noTrip) {
        this.startDate = TODAY;
        this.endDate = TODAY;
        this.startSelected = false;
        this.endSelected = false;
      }
    },
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
      var text = "";
      if (!this.noTrip) {
        if (!this.startSelected) {
          text = "لطفا زمان شروع را انتخاب کنید.";
        } else if (!this.endSelected) {
          text = "لطفا زمان پایان را انتخاب کنید.";
        } else if (this.startDate > this.endDate) {
          text = "زمان شروع بایستی پیش از زمان پایان باشد.";
        }
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        let from = this.noTrip ? "" : this.startDate;
        let to = this.noTrip ? "" : this.endDate;
        saveLastKhorooj(this.lastKhorooj.RequestID, from, to, this.noTrip)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.goToIndex();
            }
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    appDialog: Dialog,
  },
  /**
   * get khorooji meta data
   */
  created() {
    this.$store.dispatch("getLastKhorooj").then(() => {
      if (this.lastKhorooj.RequestID == 0) {
        this.$store.commit("SET_DIALOG_ICON", "exclamation");

        this.$store.commit("SET_DIALOG_TYPE", 0);

        this.$store.commit(
          "SET_DIALOG_MESSAGE",
          "تا به حال برای شما مجوز هیچ گونه سفری صادر نشده است."
        );
        this.$store.commit("SET_DIALOG_SHOW", true);
      }
    });
  },
  computed: {
    lastKhorooj() {
      return this.$store.getters.lastKhorooj;
    },
    fullText() {
      return (
        "<li>شما برای خروج از کشور به مقصد " +
        this.lastKhorooj.Country +
        " از تاریخ " +
        this.lastKhorooj.AzTarikh +
        " تا تاریخ " +
        this.lastKhorooj.TaTarikh +
        " مجوز داشته اید.</li>" +
        "<li>خواهشمند است بعد از سفر، اقدام به ثبت تاریخ دقیق رفت و برگشت خود نمائید.</li>" +
        "<li>این تاریخ ها براساس مهرهای قرمز و آبی رنگی که بر روی گذرنامه شما (هنگام عبور از مرز) حک شده است، قابل تشخیص می باشد(مانند تصویر نمونه)</li>" +
        "<li>تاریخ ها را بصورت شمسی وارد نمائید</li>" +
        "<li>در صورتیکه به سفر نرفته اید، گزینه عدم سفر را کلیک فرمائید</li>"
      );
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
  border: 2px black solid;
  float: right;
  width: 100%;
}

.img {
  width: 100%;
  padding: 15px;
  float: right;
  background-color: white;
}

.description {
  display: table;
  z-index: 0;
}
.form {
  display: flow-root;
}

.register {
  width: 300px !important;
  margin: 15px auto;
}

ul {
  padding: 0px 15px !important;
}

@media only screen and (min-width: 600px) {
  .form-center {
    margin: auto;
  }
  .form {
    width: 500px;
    margin: 15px auto;
  }
}
@media only screen and (min-width: 768px) {
  .img {
    width: 50%;
    padding: 15px;
    display: flex;
  }
  .description {
    width: 50%;
    display: block;
  }

  .v-card__title {
    border: none;
  }

  .parent {
    display: flex;
    width: 100%;
    float: right;
  }
}

@media only screen and (min-width: 1366px) {
  .parent {
    width: 67%;
  }

  .form {
    float: right;
    width: 32%;
  }
}
</style>
